import { render, staticRenderFns } from "./view-wrap.vue?vue&type=template&id=bc73eac6"
import script from "./view-wrap.vue?vue&type=script&lang=js"
export * from "./view-wrap.vue?vue&type=script&lang=js"
import style0 from "./view-wrap.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports